<template>
    <QuestionWrapper :isCardLayout="false" v-bind="{...$props, ...$attrs}">
        <template v-slot:question>
            <p v-html="question.comments"/>
        </template>
    </QuestionWrapper>
</template>

<script>
    import questionMixin from "@/components/pages/registration/questions/questionMixin";

    export default {
        name: "TextQuestion",
        mixins: [questionMixin],

    }
</script>

<style scoped>

</style>
